export const clientId = document.querySelector<HTMLMetaElement>('meta[name="client-id"]')?.content
export const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const isForm = options?.body instanceof FormData
  const res = await fetch(`/${clientId}/api/v1${path}`, {
    ...options,
    headers: {
      // The browser sets the multipart boundary itself for FormData.
      ...(isForm ? {} : { "Content-Type": "application/json" }),
      "X-CSRF-Token": csrfToken ?? "",
      ...options?.headers,
    },
  })
  if (res.status === 401) {
    window.location.href = `/${clientId}/session/new`
    throw new Error("Unauthorized")
  }
  if (!res.ok) throw new Error(await res.text())
  if (res.status === 204) return undefined as T
  return res.json()
}

export const api = {
  get: <T>(path: string) => apiFetch<T>(path),
  post: <T>(path: string, body?: unknown) =>
    apiFetch<T>(path, { method: "POST", body: JSON.stringify(body) }),
  patch: <T>(path: string, body?: unknown) =>
    apiFetch<T>(path, { method: "PATCH", body: JSON.stringify(body) }),
  put: <T>(path: string, body?: unknown) =>
    apiFetch<T>(path, { method: "PUT", body: JSON.stringify(body) }),
  putForm: <T>(path: string, form: FormData) => apiFetch<T>(path, { method: "PUT", body: form }),
  del: <T>(path: string) => apiFetch<T>(path, { method: "DELETE" }),
}
